import { setupAuthInterceptor } from "@/utils/setupAuthInterceptor";
import axios, { AxiosError } from "axios";
import type { AxiosInstance, AxiosResponse } from "axios";

const baseURL =
  import.meta.env.VITE_ENTREGA_REPORTE_API_URL || "http://localhost:4000";

export const axiosEntregaReporteSync: AxiosInstance = axios.create({
  baseURL,
  headers: {
    "Content-Type": "application/json",
  },
});

setupAuthInterceptor(axiosEntregaReporteSync);

axiosEntregaReporteSync.interceptors.response.use(
  (response: AxiosResponse) => response,
  async (error: AxiosError) =>
    Promise.reject(error.response || "Algo salió mal"),
);
